import { Navigate, Route, Routes } from 'react-router-dom'
import Signup from './Signup'
import AcceptInvitation from './pages/AcceptInvitation'
import Login from './Login'
import ForgotPasswordPage from './pages/forgot-password'
import ResetPasswordPage from './pages/reset-password'
import { TermsOfServicePage } from './pages/TermsOfServicePage'
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage'

type AuthRoutesProps = {
  onSignupSuccess: (payload: { email: string; password: string }) => void | Promise<void>
  isLoggingIn: boolean
}

export default function AuthRoutes({ onSignupSuccess, isLoggingIn }: AuthRoutesProps) {
  return (
    <Routes>
      <Route path="signup" element={<Signup onSuccess={onSignupSuccess} />} />
      <Route path="accept-invitation" element={<AcceptInvitation onSuccess={onSignupSuccess} />} />
      <Route path="login" element={<Login login={onSignupSuccess} isLoggingIn={isLoggingIn} />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="reset-password" element={<ResetPasswordPage />} />
      <Route path="terms-of-service" element={<TermsOfServicePage />} />
      <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  )
}
